import * as client from "../../api/client";

export const REQUEST_PLACES = 'PLACES/REQUEST';
export const RECEIVE_PLACES = 'PLACES/RECEIVE';

export const fetchPlaces = () => dispatch => {
  dispatch({ type: REQUEST_PLACES });

  return client.get('/api/public/places')
    .then(json => {
      dispatch({ type: RECEIVE_PLACES, json });
    })
    .catch(console.error);
};

const initialState = {
  items: [],
  pending: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PLACES: {
      return { ...state, pending: true };
    }
    case RECEIVE_PLACES: {
      const items = state.items.concat(action.json);
      return { ...state, items, pending: false  };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/places.js